/*
  UserDeleteSkillButton
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, bindActionCreators } from 'redux';
import injectReducer from 'utils/injectReducer';
import UserDeleteSkillButtonReducer from 'store/graphql/UserDeleteSkillButton/reducer';

import Button from 'ui/common/button';

import messages from './messages';
import * as actionTypes from 'store/graphql/UserDeleteSkillButton/action-types';
import * as flashActions from 'store/features/common/flash/actions';

import { selectIsDeletingUserSkill } from 'store/graphql/UserDeleteSkillButton/selectors';
import { selectCurrentUserId } from 'store/features/auth/selectors';

class UserDeleteSkillButton extends Component {
  static propTypes = {
    userId: PropTypes.string,
    skillName: PropTypes.string,
    skillId: PropTypes.string,
    color: PropTypes.string,
    isReady: PropTypes.bool,
    closeModalFn: PropTypes.func,
  };

  constructor(props) {
    super(props);
    autoBind(this);
  }

  async onDelete(entry) {
    const {
      client,
      deleteUserSkillStart,
      deleteUserSkillSuccess,
      deleteUserSkillFailure,
      addMessage,
      intl: { formatMessage },
      closeModalFn,
    } = this.props;
    const { userId, skillName, skillId } = entry;
    deleteUserSkillStart();

    try {
      const response = await client.mutate({
        mutation: gql`
          mutation skillDelete($name: String!) {
            skillDelete(name: $name) {
              skillDeleted
            }
          }
        `,
        variables: {
          name: skillName,
        },
      });

      const { data, error } = response;

      if (error && error[0].message) {
        deleteUserSkillFailure({ error: error[0].message });
      } else if (data) {
        deleteUserSkillSuccess({ userId, skillId });
        closeModalFn();
        addMessage({
          id: 'graphql.user.delete.skill.success',
          kind: 'success',
          content: formatMessage(messages.success, { skillName }),
        });
      }
    } catch (error) {
      deleteUserSkillFailure({ error });
    }
  }

  render() {
    const {
      userId,
      skillName,
      skillId,
      color,
      isReady,
      isDeletingUserSkill,
      children,
      ...other
    } = this.props;

    return (
      <Button
        iconPosition="suffix"
        loading={isDeletingUserSkill}
        onClick={() => this.onDelete({ userId, skillName, skillId })}
        color={color}
        isReady={isReady}
        {...other}
      >
        {children}
      </Button>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const isDeletingUserSkill = selectIsDeletingUserSkill(state);
  const userIdFromProps = ownProps && ownProps.userId;
  const currentUserId = userIdFromProps ? userIdFromProps : selectCurrentUserId(state);

  return {
    isDeletingUserSkill,
    userId: currentUserId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    deleteUserSkillStart: () => dispatch({ type: actionTypes.DELETE_USER_SKILL.START }),
    deleteUserSkillSuccess: ({ userId, skillId }) =>
      dispatch({
        type: actionTypes.DELETE_USER_SKILL.SUCCESS,
        payload: {
          userId,
          skillId,
        },
      }),
    deleteUserSkillFailure: error =>
      dispatch({ type: actionTypes.DELETE_USER_SKILL.FAILURE, payload: { error } }),
    addMessage: bindActionCreators(flashActions.addMessage, dispatch),
  };
}

UserDeleteSkillButton.defaultProps = {
  closeModalFn: function() {},
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'UserDeleteSkillButton',
  reducer: UserDeleteSkillButtonReducer,
});

export default compose(withReducer, withConnect)(injectIntl(withApollo(UserDeleteSkillButton)));
